import { END_POINTS } from '../helpers';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

export const commonApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMasterData: builder.query<
      CommonResponse & { data: any },
      { search: string; vehicleId?: string; role?: number | string }
    >({
      query: ({ search, vehicleId, role }) => ({
        url: `${END_POINTS.getMasterData}?search=${search}${
          vehicleId ? `&vehicleId=${vehicleId}` : ''
        }${role ? `&role=${role}` : ''}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 30,
      providesTags: ['BRAND'],
    }),
  }),
});

export const { useLazyGetMasterDataQuery, useGetMasterDataQuery } = commonApi;
